import { createContext, ReactNode, useContext, useMemo } from 'react';
import axios, { AxiosInstance } from 'axios';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';

export interface LocalApiClientContext {
  client: AxiosInstance;
}

const ctx = createContext<LocalApiClientContext | undefined>(undefined);
ctx.displayName = 'LocalApiClient';

export interface LocalApiClientProviderProps {
  baseUrl: URL | string;
  children?: ReactNode;
}

export const LocalApiClientProvider = ({
  children,
  baseUrl,
}: LocalApiClientProviderProps) => {
  const { queryClient, ...value } = useMemo(
    () => ({
      client: axios.create({
        baseURL: new URL('/api', baseUrl.toString()).toString(),
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      }),
      queryClient: new QueryClient({
        defaultOptions: {
          queries: {
            staleTime: Infinity,
            networkMode: 'offlineFirst',
          },
        },
      }),
    }),
    [],
  );
  return (
    <QueryClientProvider client={queryClient}>
      <ctx.Provider value={value}>{children}</ctx.Provider>
    </QueryClientProvider>
  );
};

export const useLocalApiClient = () => useContext(ctx)?.client!;
